import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../Link';
import { AppStoreButton, PlayStoreButton } from '../../../AppDownloadButtons';
import Img from '../../../Img';

import styles from './styles.sass';
import LinkStyles from '../../LinkStyles.sass';

import AnchorLogoSquareSVG from '../../../svgs/AnchorLogoSquare';

const renderLink = (isAndroidChrome, isIOS) => {
  if (isAndroidChrome) {
    return (
      <span key="appLinkContainer" className={styles.appButtonWrapper}>
        <PlayStoreButton height={35} />
      </span>
    );
  }
  if (isIOS) {
    return (
      <span key="appLinkContainer" className={styles.appButtonWrapper}>
        <AppStoreButton height={35} />
      </span>
    );
  }
  return (
    <div key="linksContainer" className={styles.linksContainer}>
      <Link className={LinkStyles.link} to="/switch">
        SWITCH TO ANCHOR
      </Link>
      <div className={styles.separator} />
      <Link className={LinkStyles.link} to="/signup">
        MAKE YOUR OWN PODCAST
      </Link>
    </div>
  );
};

const ProfilePageOverrideNav = ({ isAndroidChrome, isIOS }) => (
  <div className={styles.container}>
    <a href="/" className={styles.logoLink}>
      <div className={styles.iconWrapper}>
        <AnchorLogoSquareSVG />
      </div>
      <Img
        src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-header.png"
        withRetina
        alt="Anchor logo"
        height={33}
        width={132}
        className={styles.logoImage}
      />
    </a>
    <p className={styles.profileNavText}>
      Make your own podcast for free with Anchor!
    </p>
    {renderLink(isAndroidChrome, isIOS)}
  </div>
);

ProfilePageOverrideNav.defaultProps = {
  isAndroidChrome: false,
  isIOS: false,
};
ProfilePageOverrideNav.propTypes = {
  isAndroidChrome: PropTypes.bool,
  isIOS: PropTypes.bool,
};
export { ProfilePageOverrideNav };
